import { createUseStyles } from 'react-jss'
import { sarabunFont } from '@components/Styles'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles(
  {
    root: {
      '& > div:not(:first-child)': {
        marginTop: 16,
        [forPhoneOnly]: {
          marginTop: 16,
        },
      },
    },
    childLabel: {
      ...sarabunFont({ size: 17 }),
    },
    checkbox: {
      '& > label': {
        alignItems: 'center',
      },
    },
  },
  { name: 'PatientDetails' }
)
